import { useCallback, useEffect } from 'react';
import { useNotificationsStore } from '../stores/notificationsStore';
import { useIsWaitingWelcome } from './useIsWaitingWelcome';
import { useTabIsVisible } from '../stores/tabVisibilityStore';
export const useNotification = (isMinimized, isSnappedToLatest) => {
    const { notificationsCount, setNotificationsCount } = useNotificationsStore();
    const isWaitingWelcome = useIsWaitingWelcome();
    const { isVisible } = useTabIsVisible();
    useEffect(() => {
        if (isVisible && !isMinimized && isSnappedToLatest) {
            setNotificationsCount(0);
        }
    }, [isMinimized, isSnappedToLatest, isVisible, setNotificationsCount]);
    const addNotifications = useCallback((n) => {
        if (n <= 0 || isWaitingWelcome)
            return;
        if (isMinimized || !isSnappedToLatest || !isVisible) {
            setNotificationsCount(notificationsCount + n);
        }
    }, [
        isMinimized,
        isSnappedToLatest,
        isVisible,
        isWaitingWelcome,
        notificationsCount,
        setNotificationsCount,
    ]);
    return [notificationsCount, addNotifications];
};
